var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pengumuman-container vector-background col center"},[_c('MessagePage',{attrs:{"img":_vm.img,"title":_vm.title,"msg":_vm.msg,"msg2":_vm.msg2,"isPrimary":_vm.isPrimary,"isDanger":_vm.isDanger,"goto":_vm.goto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }